import TagManager from 'react-gtm-module';

export const initGTM = () => { 
    if (process.env.NODE_ENV === 'development') {
        return;
    }

    TagManager.initialize({ gtmId: 'GTM-5SBRPSVR' }) 
};